// @flow

import * as mobx from 'mobx'
import * as React from 'react'
import PT from 'prop-types'
import moment from 'moment'
import { type Params } from '@vimcar/shared-utils/linkViewModel'
import { type Users } from '@vimcar/shared-stores/mobx/users'

import { setLanguage } from '#utils/i18n'
import { parseQueryParams } from '#utils/location'

export type ViewModel = {|
  parsedLocaleParam: void | string,
|}

export type Props = {|
  children?: React.Node,
  location: { search: string },
|}

export type Context = {|
  models: { users: Users },
|}

const QUERY_PARAM_LOCALE = 'locale'

const mkViewModel = (
  { registerAutorun }: Params,
  props: Props,
  ctx: Context
): ViewModel => {
  const vm: ViewModel = mobx.observable(({
    get parsedLocaleParam() {
      if (!props.location.search) return
      const queryParams = parseQueryParams(props.location.search)
      if (QUERY_PARAM_LOCALE in queryParams) {
        return queryParams[QUERY_PARAM_LOCALE]
      }
    },
  }: ViewModel))

  registerAutorun(() => {
    const selfUser = ctx.models.users.self

    if (!selfUser) return

    const locale: string =
      vm.parsedLocaleParam &&
      selfUser.locale !== vm.parsedLocaleParam
        ? vm.parsedLocaleParam
        : selfUser.locale

    setLanguage(locale)
    moment.updateLocale(locale)
  })

  return vm
}

mkViewModel.contextTypes = {
  models: PT.any,
}

export default mkViewModel
